import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/avatar/newAvatar.svg'


const _hoisted_1 = { class: "relative flex md:flex-row flex-col h-full" }
const _hoisted_2 = { class: "flex flex-col bg-gray-200 w-full" }
const _hoisted_3 = { class: "flex flex-col pt-8 pl-24" }
const _hoisted_4 = { class: "flex flex-row" }
const _hoisted_5 = { class: "h-12 items-center p-4 inline-flex" }
const _hoisted_6 = { class: "flex flex-col bg-gray-200 w-full p-8" }
const _hoisted_7 = { class: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 place-items-start mt-4" }
const _hoisted_8 = ["id", "onClick"]
const _hoisted_9 = { class: "flex justify-center h-10 font-semibold text-lg" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row justify-center py-1" }, [
  /*#__PURE__*/_createCommentVNode("Button\n              :childclass=\"'w-32'\"\n              :backgroundcolour=\"'bg-white'\"\n              :textcolour=\"'text-black'\"\n              class=\"mr-4\"\n              id=\"button-monitor\"\n              @vclick=\"editDetails(p)\"\n              >Details</Button\n            ")
], -1 /* HOISTED */)
const _hoisted_11 = { class: "flex flex-row justify-center px-8 pb-8 mt-4" }
const _hoisted_12 = {
  key: 0,
  class: "flex md:flex-grow flex-grow-0 relative z-10 justify-center items-center bg-repeat bg-gray-200"
}
const _hoisted_13 = { class: "flex flex-col items-center h-full pb-8" }
const _hoisted_14 = { class: "flex flex-col flex-grow justify-center items-center" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-32"
}, null, -1 /* HOISTED */)
const _hoisted_16 = { class: "mt-8 text-gray-type" }
const _hoisted_17 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_18 = { class: "flex flex-row flex-grow" }
const _hoisted_19 = {
  key: "avatar-page-0",
  class: "flex flex-col w-full items-start md:p-10 p-5"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("hr", { class: "w-full" }, null, -1 /* HOISTED */)
const _hoisted_21 = { class: "grid md:grid-cols-3 grid-cols-6 py-4" }
const _hoisted_22 = ["src"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("hr", { class: "w-full" }, null, -1 /* HOISTED */)
const _hoisted_24 = { class: "grid md:grid-cols-3 grid-cols-6 py-4" }
const _hoisted_25 = ["src"]
const _hoisted_26 = {
  key: "avatar-page-1",
  class: "flex flex-col w-full items-start md:p-10 p-5"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("hr", { class: "w-full" }, null, -1 /* HOISTED */)
const _hoisted_28 = { class: "grid md:grid-cols-4 grid-cols-6 py-4" }
const _hoisted_29 = ["src"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("hr", { class: "w-full" }, null, -1 /* HOISTED */)
const _hoisted_31 = { class: "grid md:grid-cols-4 grid-cols-6 py-4" }
const _hoisted_32 = ["src"]
const _hoisted_33 = {
  key: "avatar-page-2",
  class: "flex flex-col w-full items-start md:p-10 p-5"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("hr", { class: "w-full" }, null, -1 /* HOISTED */)
const _hoisted_35 = { class: "grid md:grid-cols-4 grid-cols-6 py-4" }
const _hoisted_36 = ["src"]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("hr", { class: "w-full" }, null, -1 /* HOISTED */)
const _hoisted_38 = { class: "grid md:grid-cols-4 grid-cols-6 py-4" }
const _hoisted_39 = ["src"]
const _hoisted_40 = {
  key: "avatar-page-3",
  class: "flex flex-col w-full items-start md:p-10 p-5"
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("hr", { class: "w-full" }, null, -1 /* HOISTED */)
const _hoisted_42 = { class: "grid md:grid-cols-4 grid-cols-6 py-4" }
const _hoisted_43 = ["src"]
const _hoisted_44 = /*#__PURE__*/_createElementVNode("hr", { class: "w-full" }, null, -1 /* HOISTED */)
const _hoisted_45 = { class: "grid md:grid-cols-4 grid-cols-6 py-4" }
const _hoisted_46 = ["src"]
const _hoisted_47 = {
  key: "avatar-page-4",
  class: "flex flex-col w-full items-start md:p-10 p-5"
}
const _hoisted_48 = /*#__PURE__*/_createElementVNode("hr", { class: "w-full" }, null, -1 /* HOISTED */)
const _hoisted_49 = { class: "grid md:grid-cols-3 grid-cols-6 py-4" }
const _hoisted_50 = ["src"]
const _hoisted_51 = { class: "flex flex-row justify-center px-8 pb-8" }
const _hoisted_52 = { class: "select-none absolute top-0 left-0 m-8 flex flex-row items-center z-10" }
const _hoisted_53 = {
  key: 0,
  class: "ml-4 rounded-full w-full bg-white h-12 flex items-center p-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_ItemSelection = _resolveComponent("ItemSelection")!
  const _component_SlButton = _resolveComponent("SlButton")!
  const _component_AnswerInput = _resolveComponent("AnswerInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.mode == 'select')
      ? (_openBlock(), _createBlock(_Transition, {
          key: 0,
          mode: "out-in",
          name: _ctx.transitionName
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.t('selectPlayers')), 1 /* TEXT */)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                (_ctx.user.status.canEditPlayers)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      backgroundcolour: 'bg-white',
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.newPlayer()))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t('newPlayer')), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    }))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("div", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.players, (p) => {
                    return (_openBlock(), _createBlock(_component_ItemSelection, {
                      key: p._id,
                      class: "w-48",
                      corners: true,
                      selected: p.selected,
                      colour: p.profile.avatar.backgroundColour
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          id: `div-togglePlayer-${p.profile.name}`,
                          class: "cursor-pointer flex flex-col h-full",
                          onClick: ($event: any) => (_ctx.selectplayer(p))
                        }, [
                          _createVNode(_component_Avatar, {
                            layout: p.profile.avatar,
                            class: "w-48 h-48"
                          }, null, 8 /* PROPS */, ["layout"]),
                          _createElementVNode("p", _hoisted_9, _toDisplayString(p.profile.name), 1 /* TEXT */),
                          _hoisted_10
                        ], 8 /* PROPS */, _hoisted_8)
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["selected", "colour"]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _withDirectives(_createVNode(_component_SlButton, {
                    id: "button-select",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.forward()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('edit')), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }, 512 /* NEED_PATCH */), [
                    [_vShow, _ctx.selectedPlayer]
                  ])
                ])
              ])
            ])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["name"]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(_Transition, {
            mode: "out-in",
            name: _ctx.transitionName
          }, {
            default: _withCtx(() => [
              (_ctx.mode == 'name')
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _hoisted_15,
                        _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.t('whatsYourName')), 1 /* TEXT */),
                        _createVNode(_component_AnswerInput, {
                          modelValue: _ctx.name,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.name) = $event)),
                          mode: "text",
                          "custom-size": "24",
                          underline: false,
                          class: "mt-8"
                        }, null, 8 /* PROPS */, ["modelValue"])
                      ]),
                      _createVNode(_component_SlButton, {
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.forward()))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('next')), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                      })
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "flex md:flex-grow flex-grow-0 relative z-10 justify-center items-center bg-repeat bg-gray-200",
                    style: _normalizeStyle([
            _ctx.layout.backgroundColour
              ? { backgroundColor: _ctx.layout.backgroundColour }
              : { backgroundImage: 'url(' + require('@/assets/avatar/grid.png') + ')' },
          ])
                  }, [
                    _createVNode(_component_Avatar, {
                      class: "w-full",
                      layout: _ctx.layout
                    }, null, 8 /* PROPS */, ["layout"])
                  ], 4 /* STYLE */))
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["name"]),
          (_ctx.mode == 'avatar')
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_Transition, {
                    mode: "out-in",
                    name: _ctx.transitionName
                  }, {
                    default: _withCtx(() => [
                      (_ctx.page === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                            _createElementVNode("p", null, _toDisplayString(_ctx.t('eyeShapes')), 1 /* TEXT */),
                            _hoisted_20,
                            _createElementVNode("div", _hoisted_21, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.eyeShapes, (e, i) => {
                                return (_openBlock(), _createBlock(_component_ItemSelection, {
                                  key: `eyeshape-${e}`,
                                  class: "w-24",
                                  colour: '#F5F5F5',
                                  corners: true,
                                  selected: i.toString() == _ctx.layout.eyeShape,
                                  onClick: ($event: any) => (_ctx.setStyle('eyeShape', i))
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("img", { src: e }, null, 8 /* PROPS */, _hoisted_22)
                                  ]),
                                  _: 2 /* DYNAMIC */
                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["selected", "onClick"]))
                              }), 128 /* KEYED_FRAGMENT */))
                            ]),
                            _createElementVNode("p", null, _toDisplayString(_ctx.t('eyeColour')), 1 /* TEXT */),
                            _hoisted_23,
                            _createElementVNode("div", _hoisted_24, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.eyeColours, (e) => {
                                return (_openBlock(), _createBlock(_component_ItemSelection, {
                                  key: `eyecolour-${e}`,
                                  class: "w-24",
                                  colour: e,
                                  corners: false,
                                  selected: e == _ctx.layout.eyeColour,
                                  onClick: ($event: any) => (_ctx.setStyle('eyeColour', e))
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("img", { src: _ctx.emptyImage }, null, 8 /* PROPS */, _hoisted_25)
                                  ]),
                                  _: 2 /* DYNAMIC */
                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["colour", "selected", "onClick"]))
                              }), 128 /* KEYED_FRAGMENT */))
                            ])
                          ]))
                        : (_ctx.page === 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                              _createElementVNode("p", null, _toDisplayString(_ctx.t('skinColour')), 1 /* TEXT */),
                              _hoisted_27,
                              _createElementVNode("div", _hoisted_28, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.skinColours, (e) => {
                                  return (_openBlock(), _createBlock(_component_ItemSelection, {
                                    key: `skincolour-${e}`,
                                    class: "w-24",
                                    colour: e,
                                    corners: false,
                                    selected: e == _ctx.layout.skinColour,
                                    onClick: ($event: any) => (_ctx.setStyle('skinColour', e))
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("img", { src: _ctx.emptyImage }, null, 8 /* PROPS */, _hoisted_29)
                                    ]),
                                    _: 2 /* DYNAMIC */
                                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["colour", "selected", "onClick"]))
                                }), 128 /* KEYED_FRAGMENT */))
                              ]),
                              _createElementVNode("p", null, _toDisplayString(_ctx.t('lipColour')), 1 /* TEXT */),
                              _hoisted_30,
                              _createElementVNode("div", _hoisted_31, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lipColours, (e) => {
                                  return (_openBlock(), _createBlock(_component_ItemSelection, {
                                    key: `lipColour-${e}`,
                                    class: "w-24",
                                    colour: e,
                                    corners: false,
                                    selected: e == _ctx.layout.lipColour,
                                    onClick: ($event: any) => (_ctx.setStyle('lipColour', e))
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("img", { src: _ctx.emptyImage }, null, 8 /* PROPS */, _hoisted_32)
                                    ]),
                                    _: 2 /* DYNAMIC */
                                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["colour", "selected", "onClick"]))
                                }), 128 /* KEYED_FRAGMENT */))
                              ])
                            ]))
                          : (_ctx.page === 2)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                _createElementVNode("p", null, _toDisplayString(_ctx.t('hairShapes')), 1 /* TEXT */),
                                _hoisted_34,
                                _createElementVNode("div", _hoisted_35, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hairShapes, (e, i) => {
                                    return (_openBlock(), _createBlock(_component_ItemSelection, {
                                      key: `hairShape-${e}`,
                                      class: "w-24",
                                      colour: '#F5F5F5',
                                      corners: true,
                                      selected: i.toString() == _ctx.layout.hairShape,
                                      onClick: ($event: any) => (_ctx.setStyle('hairShape', i))
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("img", { src: e }, null, 8 /* PROPS */, _hoisted_36)
                                      ]),
                                      _: 2 /* DYNAMIC */
                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["selected", "onClick"]))
                                  }), 128 /* KEYED_FRAGMENT */))
                                ]),
                                _createElementVNode("p", null, _toDisplayString(_ctx.t('hairColour')), 1 /* TEXT */),
                                _hoisted_37,
                                _createElementVNode("div", _hoisted_38, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hairColours, (e) => {
                                    return (_openBlock(), _createBlock(_component_ItemSelection, {
                                      key: `hairColour-${e}`,
                                      class: "w-24",
                                      colour: e,
                                      corners: false,
                                      selected: e == _ctx.layout.hairColour,
                                      onClick: ($event: any) => (_ctx.setStyle('hairColour', e))
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("img", { src: _ctx.emptyImage }, null, 8 /* PROPS */, _hoisted_39)
                                      ]),
                                      _: 2 /* DYNAMIC */
                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["colour", "selected", "onClick"]))
                                  }), 128 /* KEYED_FRAGMENT */))
                                ])
                              ]))
                            : (_ctx.page === 3)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                  _createElementVNode("p", null, _toDisplayString(_ctx.t('nose')), 1 /* TEXT */),
                                  _hoisted_41,
                                  _createElementVNode("div", _hoisted_42, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.noseShapes, (e, i) => {
                                      return (_openBlock(), _createBlock(_component_ItemSelection, {
                                        key: `noseShape-${e}`,
                                        class: "w-24",
                                        colour: '#F5F5F5',
                                        corners: true,
                                        selected: i.toString() == _ctx.layout.noseShape,
                                        onClick: ($event: any) => (_ctx.setStyle('noseShape', i))
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("img", { src: e }, null, 8 /* PROPS */, _hoisted_43)
                                        ]),
                                        _: 2 /* DYNAMIC */
                                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["selected", "onClick"]))
                                    }), 128 /* KEYED_FRAGMENT */))
                                  ]),
                                  _createElementVNode("p", null, _toDisplayString(_ctx.t('accessories')), 1 /* TEXT */),
                                  _hoisted_44,
                                  _createElementVNode("div", _hoisted_45, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accessories, (e, i) => {
                                      return (_openBlock(), _createBlock(_component_ItemSelection, {
                                        key: `accessories-${e}`,
                                        class: "w-24",
                                        colour: '#F5F5F5',
                                        corners: true,
                                        selected: i.toString() == _ctx.layout.accessories,
                                        onClick: ($event: any) => (!_ctx.accessoryAlreadyInUse(i) && _ctx.setStyle('accessories', i))
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("img", {
                                            src: e,
                                            class: _normalizeClass({ 'opacity-10': _ctx.accessoryAlreadyInUse(i) })
                                          }, null, 10 /* CLASS, PROPS */, _hoisted_46)
                                        ]),
                                        _: 2 /* DYNAMIC */
                                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["selected", "onClick"]))
                                    }), 128 /* KEYED_FRAGMENT */))
                                  ])
                                ]))
                              : (_ctx.page === 4)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                    _createElementVNode("p", null, _toDisplayString(_ctx.t('background')), 1 /* TEXT */),
                                    _hoisted_48,
                                    _createElementVNode("div", _hoisted_49, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.backgrounds, (b) => {
                                        return (_openBlock(), _createBlock(_component_ItemSelection, {
                                          key: `background-${b}`,
                                          class: "w-24",
                                          colour: b,
                                          corners: false,
                                          selected: b == _ctx.layout.backgroundColour,
                                          onClick: ($event: any) => (_ctx.setStyle('backgroundColour', b))
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("img", { src: _ctx.emptyImage }, null, 8 /* PROPS */, _hoisted_50)
                                          ]),
                                          _: 2 /* DYNAMIC */
                                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["colour", "selected", "onClick"]))
                                      }), 128 /* KEYED_FRAGMENT */))
                                    ])
                                  ]))
                                : _createCommentVNode("v-if", true)
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["name"])
                ]),
                _createElementVNode("div", _hoisted_51, [
                  _createVNode(_component_SlButton, {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.forward()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.page === 4 ? 'Done' : 'Continue'), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  })
                ])
              ]))
            : _createCommentVNode("v-if", true)
        ], 64 /* STABLE_FRAGMENT */)),
    _createElementVNode("div", _hoisted_52, [
      _createVNode(_component_SlButton, {
        "extra-classes": "w-12",
        "background-class": "bg-red-button",
        logo: "leftArrow",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.back()))
      }),
      (_ctx.mode == 'avatar')
        ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
            _createElementVNode("p", null, _toDisplayString(_ctx.t('customise')), 1 /* TEXT */)
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}